import type { MantineThemeOverride } from '@mantine/core'
import { px, uiTokens } from './tokens'
const ember: string[] = Object.values(uiTokens.color.ember)
const gunmetal: string[] = Object.values(uiTokens.color.gunmetal)

export const theme: MantineThemeOverride = {
  colorScheme: 'dark',
  primaryColor: 'ember',
  colors: { ember, gunmetal },
  fontFamily: uiTokens.typography.body,
  fontFamilyMonospace: uiTokens.typography.monospace,
  headings: {
    fontFamily: uiTokens.typography.display,
    fontWeight: uiTokens.typography.weight.bold.toString(),
    sizes: {
      h1: { fontSize: px(uiTokens.typography.size.xxl) },
      h2: { fontSize: px(uiTokens.typography.size.xl) },
      h3: { fontSize: px(uiTokens.typography.size.lg) },
      h4: { fontSize: px(uiTokens.typography.size.md) },
      h5: { fontSize: px(uiTokens.typography.size.sm) },
      h6: { fontSize: px(uiTokens.typography.size.xs) }
    }
  },
  defaultRadius: 'sm',
  spacing: {
    xs: px(uiTokens.spacing.xs),
    sm: px(uiTokens.spacing.sm),
    md: px(uiTokens.spacing.md),
    lg: px(uiTokens.spacing.lg),
    xl: px(uiTokens.spacing.xl)
  },
  radius: {
    xs: px(uiTokens.radius.xs),
    sm: px(uiTokens.radius.sm),
    md: px(uiTokens.radius.md),
    lg: px(uiTokens.radius.lg),
    xl: px(uiTokens.radius.xl)
  },
  components: {
    Button: { defaultProps: { radius: 'sm' } },
    Card: { defaultProps: { radius: 'sm', withBorder: true, padding: 'md' } },
    Badge: { defaultProps: { radius: 'xs' } },
    Table: {
      defaultProps: {
        striped: true,
        highlightOnHover: true,
        withTableBorder: true
      }
    },
    Modal: { defaultProps: { radius: 'md', centered: true } },
    TextInput: { defaultProps: { radius: 'sm' } },
    Textarea: { defaultProps: { radius: 'sm' } },
    Select: { defaultProps: { radius: 'sm' } }
  }
}
